<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 417 417"
    class="svg-icon"
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
  >
    <path
      d="M155.526,138.948c67.44,0 122.192,54.753 122.192,122.193c0,67.44 -54.752,122.192 -122.192,122.192c-67.44,0 -122.193,-54.752 -122.193,-122.192c0,-67.44 54.753,-122.193 122.193,-122.193Zm-0,36.357c47.374,-0 85.836,38.462 85.836,85.836c0,47.374 -38.462,85.836 -85.836,85.836c-47.375,0 -85.836,-38.462 -85.836,-85.836c-0,-47.374 38.461,-85.836 85.836,-85.836Z"
    />
    <rect x="227.154" y="33.333" width="156.18" height="37.377" />
    <path d="M383.333,189.513l0,-156.18l-37.377,0l0,156.18l37.377,-0Z" />
    <path
      d="M253.583,189.513l120.093,-120.093l-26.429,-26.429l-120.093,120.092l26.429,26.43Z"
    />
  </svg>
</template>

<script>
export default {
  name: "IconMale"
};
</script>
